import React, { useState } from 'react';
import { Row, Col, Form } from '@/components/ui';
import { ServiceArea, ForemanArea } from '../../../services/areasService';
import FiltersCard from '../../../components/FiltersCard';
import { StandoutDropdown } from '../../../components/StandoutDropdown';

interface AreasFiltersProps {
  serviceAreas: ServiceArea[];
  foremanAreas: ForemanArea[];
  onFilterChange: (filters: { serviceArea: string; foremanArea: string }) => void;
}

const AreasFilters: React.FC<AreasFiltersProps> = ({
  serviceAreas,
  foremanAreas,
  onFilterChange
}) => {
  const [filters, setFilters] = useState({
    serviceArea: '',
    foremanArea: ''
  });

  const handleFilterChange = (field: string, value: string) => {
    const newFilters = {
      ...filters,
      [field]: value
    };
    setFilters(newFilters);
    onFilterChange(newFilters);
  };

  const clearFilters = () => {
    const clearedFilters = {
      serviceArea: '',
      foremanArea: ''
    };
    setFilters(clearedFilters);
    onFilterChange(clearedFilters);
  };

  const hasActiveFilters = filters.serviceArea !== '' || filters.foremanArea !== '';

  return (
    <FiltersCard
      title="Area Filters"
      subtitle="Filter by service area and foreman area"
      collapsible={true}
      defaultCollapsed={false}
      showClearButton={true}
      onClear={clearFilters}
      hasActiveFilters={hasActiveFilters}
    >
      <Row className="tw-mb-2">
        <Col>
          <Form.Label className="tw-mb-0" style={{ fontSize: '0.9rem', fontWeight: '600', color: '#212529' }}>
            Primary Filters
          </Form.Label>
        </Col>
      </Row>
      <Row className="tw-items-end">
        <Col md={4}>
          <StandoutDropdown<ServiceArea>
            type="searchable"
            options={serviceAreas}
            value={filters.serviceArea}
            onChange={(value) => handleFilterChange('serviceArea', value)}
            getValue={(area) => area.name}
            formatOption={(area) => `${area.name}${area.code ? ` (${area.code})` : ''}`}
            placeholder="All Service Areas"
            className="tw-w-full"
            label="Filter by Service Area"
            noOptionsMessage="No service areas available"
          />
        </Col>

        <Col md={4} className="md:tw-ml-3">
          <StandoutDropdown<ForemanArea>
            type="searchable"
            options={foremanAreas}
            value={filters.foremanArea}
            onChange={(value) => handleFilterChange('foremanArea', value)}
            getValue={(area) => area.name}
            formatOption={(area) => `${area.name}${area.code ? ` (${area.code})` : ''}`}
            placeholder="All Foreman Areas"
            className="tw-w-full"
            label="Filter by Foreman Area"
            noOptionsMessage="No foreman areas available"
          />
        </Col>
      </Row>
    </FiltersCard>
  );
};

export default AreasFilters;